import PosthogService from '~/services/posthog/PosthogService';
import { REDESIGN_SIGNUP_DESIGN_DATE } from '~/services/posthog/events';

/**
 * Fires when the user clicks the "Log In" header nav link.
 * Event: dental_portal:login:login_tab_clicked
 */
export function fireLoginTabClicked(): void {
  PosthogService.getInstance().track('dental_portal:login:login_tab_clicked', {
    design_date: REDESIGN_SIGNUP_DESIGN_DATE,
  });
}
